<template>
  <div>
    <el-row class="contentStyle">
      <el-col class="categoryStyle"
              v-show="categoryShow"
              :sm="5"
              :md="4"
              :lg="3">
        <!-- <el-menu>
          <el-menu-item v-for="(item,index) in title" :key="index" @click="classclick(item)">
            <span>{{item}}</span>
          </el-menu-item>
        </el-menu>-->
        <el-tree :data="category"
                 :props="defaultProps"
                 @node-click="categoryClick"></el-tree>
      </el-col>
      <el-col v-show="titleShow"
              class="tableStyle"
              v-loading="isLoading"
              :xs="16"
              :sm="17"
              :md="18"
              :lg="19">
        <el-table :data="content"
                  style="width: 100%">
          <el-table-column prop="title"
                           label="标题">
            <template slot-scope="scope">
              <el-button type="text"
                         size="medium"
                         @click="openTheme(scope.row._id)">{{scope.row.title}}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="author"
                           width="150"
                           label="作者"></el-table-column>
          <el-table-column prop="views"
                           width="100"
                           label="阅读量"></el-table-column>
          <el-table-column prop="time"
                           width="150"
                           label="时间"></el-table-column>
        </el-table>
      </el-col>
      <el-col v-show="!titleShow"
              :xs="16"
              :sm="17"
              :md="18"
              :lg="19"
              v-loading="isLoading"
              class="article">

        <h3 style="margin:5px 10px;">
          <i @click="titleShow=!titleShow;editHeight()"
             class="el-icon-back backButton"></i>
          &nbsp;
          {{article.title}}
        </h3>
        <div class="header">
          <span>时间：{{article.time}}</span>
          <span>作者：{{article.author}}</span>
          <span>阅读量：{{article.views}}</span>
        </div>
        <div class="body"
             ref="article">
          <mavon-editor v-html="article.htmlText"
                        style="padding: 10px;z-index: 1;"
                        :subfield="false"
                        :defaultOpen="preview"
                        :toolbarsFlag="false"
                        :boxShadow="false" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isLoading: true,
      width: 0,
      titleShow: true,
      categoryShow: true,
      defaultProps: {
        children: "children",
        label: "categoryName"
      },
      category: [],
      content: [],
      article: {}
    };
  },
  watch: {
  },

  mounted () {
    let that = this
    window.onresize = function () {
      that.editHeight()
    }
  },

  created () {
    let vm = this;
    let result = [];
    this.axios
      .post(this.apipath.baseurl + "/front/findFatherCategory", {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
      .then(resolve => {
        result = resolve.data.data;
        (async function cycle (i) {
          if (i == result.length) {
            vm.category = result;
            console.log(result)
            vm.content = (await vm.getDetailTitle("")).data.data;
            vm.isLoading = false
            return;
          }
          let params = new URLSearchParams({
            fatherId: result[i]._id
          });
          let sonJson = await vm.axios.post(
            vm.apipath.baseurl + "/front/findSonCategory",
            params,
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded"
              }
            }
          );
          result[i].children = sonJson.data.data;
          cycle(i + 1);
        })(0);
      });
  },
  methods: {
    editHeight () {
      if (window.innerWidth < 768) {
        this.$refs.article.style.maxHeight = (window.innerHeight - 180) + 'px';
      } else {
        this.$refs.article.style.maxHeight = (window.innerHeight - 180) + 'px';
      }

      if (window.innerWidth < 768 && !this.titleShow) {
        this.categoryShow = false
      } else {
        this.categoryShow = true
      }
    },

    async getDetailTitle (categoryId) {
      let params = new URLSearchParams({
        categoryId: categoryId
      });
      let result = await this.axios.post(
        this.apipath.baseurl + "/front/findDetailTitle",
        params,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        }
      );
      result.data.data.reverse();
      for (let obj of result.data.data) {
        console.log(obj);
        obj.time = obj.time.toString().split("T")[0];
      }
      return result;
    },
    async categoryClick (item) {
      this.titleShow = true;
      if (item.children) {
        let vm = this;
        let titleArr = [];
        (async function cycle (i, item, titleArr) {
          if (i == item.children.length) {
            vm.content = titleArr;
            return;
          }
          let result = (await vm.getDetailTitle(item.children[i]._id)).data
            .data;
          console.log(result);
          result.length == 0 ? null : titleArr.push.apply(titleArr, result);
          console.log(titleArr);
          cycle(i + 1, item, titleArr);
        })(0, item, titleArr);
      } else if (!item.children) {
        this.content = (await this.getDetailTitle(item._id)).data.data;
      }
    },
    //点击标题打开文章
    async openTheme (id) {
      this.isLoading = true
      let params = new URLSearchParams({
        _id: id
      });
      let result = await this.axios.post(
        this.apipath.baseurl + "/front/findDetail",
        params,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        }
      );
      this.article = result.data.data;
      this.isLoading = false
      this.article.time = this.article.time.toString().split("T")[0];
      this.titleShow = false;
      this.editHeight()
    }
  }
};
</script>

<style lang="scss" scope>
.cell {
  max-height: 60px;
  line-height: 20px !important;
}
.article {
  background-color: aliceblue;
  .header > span {
    margin: 5px 10px;
  }
  .backButton {
    cursor: pointer;
  }
  .body {
    margin: 5px 0;
    overflow-y: auto;
  }
  .body::-webkit-scrollbar {
    /* 对应纵向滚动条的宽度 */
    width: 10px;
    /* 对应横向滚动条的宽度 */
    height: 10px;
  }

  /* 滚动条上的滚动滑块 */
  .body::-webkit-scrollbar-thumb {
    background-color: #49b1f5;
    /* 关键代码 */
    background-image: -webkit-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.4) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.4) 50%,
      rgba(255, 255, 255, 0.4) 75%,
      transparent 75%,
      transparent
    );
    border-radius: 32px;
  }

  /* 滚动条轨道 */
  .body::-webkit-scrollbar-track {
    background-color: #dbeffd;
    border-radius: 32px;
  }
}
.contentStyle {
  display: flex;
  justify-content: space-around;
  height: 100%;
  padding-bottom: 100px;
}
.tableStyle > div {
  height: 100%;
  overflow-y: auto;
}
.tableStyle > div::-webkit-scrollbar {
  /* 对应纵向滚动条的宽度 */
  width: 10px;
  /* 对应横向滚动条的宽度 */
  height: 10px;
}

/* 滚动条上的滚动滑块 */
.tableStyle > div::-webkit-scrollbar-thumb {
  background-color: #49b1f5;
  /* 关键代码 */
  background-image: -webkit-linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.4) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.4) 50%,
    rgba(255, 255, 255, 0.4) 75%,
    transparent 75%,
    transparent
  );
  border-radius: 32px;
}

/* 滚动条轨道 */
.tableStyle > div::-webkit-scrollbar-track {
  background-color: #dbeffd;
  border-radius: 32px;
}
@media screen and (max-width: 768px) {
  .contentStyle {
    flex-wrap: wrap;
  }
  .categoryStyle {
    width: 100%;
  }
  .tableStyle {
    margin-top: 20px;
    padding-bottom: 120px;
    width: 100%;
    position: relative;
  }
  .article {
    width: 100%;
  }
}
</style>

